import React, { useCallback, useEffect, useState } from 'react';
import { Box, HStack, IconButton, Text, Textarea, VStack } from '@chakra-ui/react';
import 'top-loader-service/TopLoaderService.css';
import './EditInternationalOrder.scss';
import { Tooltip } from '@/components/ui/tooltip';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { Field } from '@/components/ui/field';

const Comments = ({ isInEditMode, internalComments, externalComments, handleChangeValue }) => {
  const [internalComment, setInternalComment] = useState(internalComments);
  const [externalComment, setExternalComment] = useState(externalComments);

  const handleInternalCommentChange = useCallback(e => setInternalComment(e.target.value), []);

  const handleExternalCommentChange = useCallback(e => setExternalComment(e.target.value), []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleChangeValue('internalComments', internalComment);
    }, 300);
    return () => clearTimeout(timeout);
  }, [internalComment]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleChangeValue('externalComments', externalComment);
    }, 300);
    return () => clearTimeout(timeout);
  }, [externalComment]);

  return (
    <>
      <Text fontWeight="bold" my="1.5em">
        Comments
      </Text>
      <VStack align="stretch">
        <HStack gap="42px" width="100%">
          <Box width="100%">
            <Field
              label={
                <>
                  Internal Comments&nbsp;
                  <Tooltip
                    content="Used for internal notes or remarks on orders or processes."
                    positioning={{ placement: 'right-end' }}
                  >
                    <IconButton
                      width="14px"
                      height="14px"
                      padding="0"
                      minW="auto"
                      borderRadius="50%"
                      color="#878787"
                      variant="unstyled"
                    >
                      <IoInformationCircleOutline size="14px" />
                    </IconButton>
                  </Tooltip>
                </>
              }
            >
              <Textarea
                backgroundColor="white"
                className="form-control"
                disabled={!isInEditMode}
                id="internalComments"
                name="internalComments"
                value={internalComment}
                onChange={handleInternalCommentChange}
                rows="4"
              />
            </Field>
          </Box>
          <Box width="100%">
            <Field
              label={
                <>
                  External Comments&nbsp;
                  <Tooltip
                    content="Notes or remarks for external stakeholders, like customers or suppliers."
                    positioning={{ placement: 'right-end' }}
                  >
                    <IconButton
                      width="14px"
                      height="14px"
                      padding="0"
                      minW="auto"
                      borderRadius="50%"
                      color="#878787"
                      variant="unstyled"
                    >
                      <IoInformationCircleOutline size="14px" />
                    </IconButton>
                  </Tooltip>
                </>
              }
            >
              <Textarea
                backgroundColor="white"
                className="form-control"
                disabled={!isInEditMode}
                id="externalComments"
                name="externalComments"
                value={externalComment}
                onChange={handleExternalCommentChange}
                rows="4"
              />
            </Field>
          </Box>
        </HStack>
      </VStack>
    </>
  );
};

export default Comments;
